import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=5ffbdc2f&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ffbdc2f')) {
      api.createRecord('5ffbdc2f', component.options)
    } else {
      api.reload('5ffbdc2f', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=5ffbdc2f&", function () {
      api.rerender('5ffbdc2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HwDNolf4SlRX/JS/comp/ErrorMessage.vue"
export default component.exports